import React from 'react';
import './cta-sec6.css'

const CTAsec6 = (props) => {
    return ( 
        <button className='cta-sec6'>
            {props.title}
        </button>
     );
}
 
export default CTAsec6;